<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">涉猎知识，智慧深渊，</p>
        <p  class="font1" style="padding-top: 1vh;">修炼心灵，启迪前程。</p>

        <div style="width: 87%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 八月主题课程推荐：</p>
            <!-- <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=34060">{{ themeLink[0].Name }}</a> -->
            <ul v-for="(item,index) in themeLink" :key="index" ref="">
                <a :href="item.link" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">{{ item.Name }}</li></a>
            </ul>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            themeLink:''
        }
    }, 
    created(){
        // const coc=JSON.parse(this.ReportData.coc)
        this.themeLink=JSON.parse(this.ReportData.themeLink)
    },
    computed:{},
    mounted(){
        
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo2.png") right  top  no-repeat,
                url("../../assets/24July/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #176ed2;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #176ed2;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>